export default (val: any): val is undefined => val === undefined;
